import { ChangeDetectionStrategy, Component, computed, inject, OnInit } from '@angular/core';
import { UtilityService } from '@eforall/common';
import { DialogService, GridContentWidget, PageTabsMainTabGridSize } from '@eforall/dashboard';
import { AppService, DomainDataService } from '../../../../../services';
import { VolunteeringAreaService } from '../../../volunteering-area.service';
import { VolunteeringProspectsService } from '../../volunteering-prospects.service';
import { getSetup } from './grid/get-setup';

@Component({
	selector: 'all-closed-view-part',
	standalone: true,
	imports: [GridContentWidget],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './all-closed.part.html',
})
export class AllClosedViewPart implements OnInit {

	private readonly util = inject(UtilityService);
	public readonly areaService = inject(VolunteeringAreaService);
	public readonly pageService = inject(VolunteeringProspectsService);
	private readonly domainDataService = inject(DomainDataService);
	private readonly dialogService = inject(DialogService);
	private readonly app = inject(AppService);

	public setup = getSetup(this.pageService, this.util, this.domainDataService, this.dialogService, this.app, this.areaService);

	public pageTabsGridSize = computed<PageTabsMainTabGridSize | undefined>(() => {
		if (this.pageService.layout()) return { layout: this.pageService.layout()!, viewSelector: true };
		return undefined;
	});

	ngOnInit() {
		this.pageService.getAllClosedVolunteers();
	}

}